import { actions } from './actions';
import { mutations } from './mutations';
export var state = {
    formTemplate: null,
    loading: false,
};
export var publicFormTemplates = {
    state: state,
    namespaced: true,
    actions: actions,
    mutations: mutations,
};
